import { camelizeKeys } from "humps";

import { getPrettyUrl, getPreviewToken } from "get_base_uri";

import { checkStatus, parseJSON, postRequest } from "helpers/ajax_request";
import { ORDERS_URL } from "api_urls";

function postOrder(order) {
  const prettyUrl = getPrettyUrl();
  const previewToken = getPreviewToken();

  const endpoint = `${ORDERS_URL}/${prettyUrl}/order${
    previewToken ? `?preview_token=${previewToken}` : ""
  }`;
  return fetch(endpoint, postRequest(order))
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys);
}

function registerCard(cardInfo) {
  return fetch(`${ORDERS_URL}/card_registration`, postRequest(cardInfo))
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys);
}

export { postOrder, registerCard };
